/**
 * File extension values used on the application

 * @readonly
 * @constant
 */

export default {
  XLS: 1,
  CSV: 2,
};
